const config = () => {
  const MODE = process.env.REACT_APP_MODE;
  const API_URL = process.env.REACT_APP_API_URL;
  const MOCK_API_URL = process.env.REACT_APP_MOCK_API_URL;
  const CLOUDFRONT_DISTRIBUTION_URL = process.env.REACT_APP_CLOUDFRONT_DISTRIBUTION_URL;
  const CLOUDFRONT_ALTERNATE_URL = process.env.REACT_APP_CLOUDFRONT_ALTERNATE_URL;

  return {
    MODE,
    API_URL,
    MOCK_API_URL,
    CLOUDFRONT_DISTRIBUTION_URL,
    CLOUDFRONT_ALTERNATE_URL
  };
};

export default config();
